/**
 * Stable CSS class names for E2E — Order detail address information card & address edit drawers.
 */
export const AIC = {
    root: 'order-detail-address-information-card',
    loadingGrid: 'order-detail-address-information-card__loading-grid',
    loadingInner: 'order-detail-address-information-card__loading-inner',
    drawerShippingPaper: 'order-detail-address-information-card__drawer-shipping-paper',
    drawerBillingPaper: 'order-detail-address-information-card__drawer-billing-paper',
    headerCard: 'order-detail-address-information-card__header-card',
    headerIcon: 'order-detail-address-information-card__header-icon',
    title: 'order-detail-address-information-card__title',
    divider: 'order-detail-address-information-card__divider',
    bodyCard: 'order-detail-address-information-card__body-card',
    bodyContent: 'order-detail-address-information-card__body-content',
    addressesRow: 'order-detail-address-information-card__addresses-row',
    billingColumn: 'order-detail-address-information-card__billing-column',
    billingHeaderRow: 'order-detail-address-information-card__billing-header-row',
    billingTypeIconWrap: 'order-detail-address-information-card__billing-type-icon-wrap',
    billingHeading: 'order-detail-address-information-card__billing-heading',
    inputButtonEditBilling: 'order-detail-address-information-card-input--button-edit-billing',
    billingAddressBody: 'order-detail-address-information-card__billing-address-body',
    billingSummaryLine: 'order-detail-address-information-card__billing-summary-line',
    billingEntityGrid: 'order-detail-address-information-card__billing-entity-grid',
    entityFieldLabel: 'order-detail-address-information-card__entity-field-label',
    entityFieldValue: 'order-detail-address-information-card__entity-field-value',
    shippingColumn: 'order-detail-address-information-card__shipping-column',
    shippingHeaderRow: 'order-detail-address-information-card__shipping-header-row',
    shippingIcon: 'order-detail-address-information-card__shipping-icon',
    shippingHeading: 'order-detail-address-information-card__shipping-heading',
    inputButtonEditShipping: 'order-detail-address-information-card-input--button-edit-shipping',
    shippingAddressBody: 'order-detail-address-information-card__shipping-address-body',
    shippingSummaryLine: 'order-detail-address-information-card__shipping-summary-line',
    shippingEntityGrid: 'order-detail-address-information-card__shipping-entity-grid',
    lockedGrid: 'order-detail-address-information-card__locked-grid',
    lockedInner: 'order-detail-address-information-card__locked-inner',
    lockedIcon: 'order-detail-address-information-card__locked-icon',
    lockedBlurContent: 'order-detail-address-information-card__locked-blur-content',
} as const;

export const AIC_UB = {
    form: 'order-detail-address-card-update-billing__form',
    root: 'order-detail-address-card-update-billing__root',
    grid: 'order-detail-address-card-update-billing__grid',
    drawerHeaderRoot: 'order-detail-address-card-update-billing__drawer-header',
    drawerHeaderTitle: 'order-detail-address-card-update-billing__drawer-header-title',
    drawerHeaderClose: 'order-detail-address-card-update-billing__drawer-header-close-icon',
    loadingWrap: 'order-detail-address-card-update-billing__loading-linear-wrap',
    addressEntityWrap: 'order-detail-address-card-update-billing__address-entity-fields',
    rowFirstName: 'order-detail-address-card-update-billing__field-row-first-name',
    rowLastName: 'order-detail-address-card-update-billing__field-row-last-name',
    rowPhone: 'order-detail-address-card-update-billing__field-row-phone',
    rowAddress: 'order-detail-address-card-update-billing__field-row-address',
    invoiceSection: 'order-detail-address-card-update-billing__invoice-section',
    invoiceFormControl: 'order-detail-address-card-update-billing__invoice-form-control',
    invoiceRadioGroup: 'order-detail-address-card-update-billing-input--radio-group-invoice-type',
    invoiceRadioIndividual: 'order-detail-address-card-update-billing-input--radio-invoice-individual',
    invoiceRadioCorporate: 'order-detail-address-card-update-billing-input--radio-invoice-corporate',
    rowCompany: 'order-detail-address-card-update-billing__field-row-company',
    rowTaxOffice: 'order-detail-address-card-update-billing__field-row-tax-office',
    rowTaxNumber: 'order-detail-address-card-update-billing__field-row-tax-number',
    rowSubmit: 'order-detail-address-card-update-billing__field-row-submit',
    inputTextFirstName: 'order-detail-address-card-update-billing-input--text-first-name',
    inputTextLastName: 'order-detail-address-card-update-billing-input--text-last-name',
    inputTextPhone: 'order-detail-address-card-update-billing-input--text-phone',
    inputTextAddress: 'order-detail-address-card-update-billing-input--text-address',
    inputTextCompany: 'order-detail-address-card-update-billing-input--text-company',
    inputTextTaxOffice: 'order-detail-address-card-update-billing-input--text-tax-office',
    inputTextTaxNumber: 'order-detail-address-card-update-billing-input--text-tax-number',
    inputButtonUpdate: 'order-detail-address-card-update-billing-input--button-update',
} as const;

export const AIC_US = {
    form: 'order-detail-address-card-update-shipping__form',
    root: 'order-detail-address-card-update-shipping__root',
    grid: 'order-detail-address-card-update-shipping__grid',
    drawerHeaderRoot: 'order-detail-address-card-update-shipping__drawer-header',
    drawerHeaderTitle: 'order-detail-address-card-update-shipping__drawer-header-title',
    drawerHeaderClose: 'order-detail-address-card-update-shipping__drawer-header-close-icon',
    loadingWrap: 'order-detail-address-card-update-shipping__loading-linear-wrap',
    addressSubtitle: 'order-detail-address-card-update-shipping__address-subtitle',
    addressEntityWrap: 'order-detail-address-card-update-shipping__address-entity-fields',
    rowFirstName: 'order-detail-address-card-update-shipping__field-row-first-name',
    rowLastName: 'order-detail-address-card-update-shipping__field-row-last-name',
    rowPhone: 'order-detail-address-card-update-shipping__field-row-phone',
    rowAddress: 'order-detail-address-card-update-shipping__field-row-address',
    rowSubmit: 'order-detail-address-card-update-shipping__field-row-submit',
    inputTextFirstName: 'order-detail-address-card-update-shipping-input--text-first-name',
    inputTextLastName: 'order-detail-address-card-update-shipping-input--text-last-name',
    inputTextPhone: 'order-detail-address-card-update-shipping-input--text-phone',
    inputTextAddress: 'order-detail-address-card-update-shipping-input--text-address',
    inputButtonUpdate: 'order-detail-address-card-update-shipping-input--button-update',
} as const;

export const aicCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
